import { Config } from '@adornis/config/config.js';

export const config = new Config('smartteams', {
  APP_URL: {
    client: true,
    env: true,
    name: 'APP_URL',
    required: true,
  },
});
